import { initModals } from './modals';
import renderAppRoot from './renderAppRoot';

export async function bootstrapApplication(): Promise<
  void | React.ReactPortal[]
> {
  if (typeof document !== 'undefined') {
    const portals = renderAppRoot();

    initModals();

    return portals;
  }
}
